import React, { useRef } from 'react';
import styled from '@emotion/styled';
import {
  sendAmount50,
  sendAmount75,
  sendAmount100,
  sendAmount150,
  sendAmount200,
  sendSuggest,
} from '../../../actions/profileTrackAction';
import useOnClickTriggerTracking from '../../../hooks/useOnclickTriggerTracking';
import colors from '../../../theme/colors';
import borders from '../../../theme/borders';
import { CustomStyledProps } from 'style/style';

const OfferPriceBtnWrapper = styled('ul')({
  display: 'flex',
  justifyContent: 'center',
  fontSize: 13,
  lineHeight: '19px',
  letterSpacing: -0.3,
  margin: 0,
  padding: 0,
  listStyle: 'none',
  textAlign: 'center',
  gap: 10,
});

const OfferPriceBtn = styled('li')(
  {
    display: 'inline-block',
    padding: '4px 8px',
    cursor: 'pointer',
    border: `1px solid ${borders.light.line1}`,
    borderRadius: 2,
    backgroundColor: '#FFFFFF',
    fontSize: 13,
    lineHeight: '9px',
    letterSpacing: -0.3,
    color: '#595959',
    '&:last-of-type': {
      marginRight: 0,
    },
  },
  (props: CustomStyledProps) =>
    props.isActive
      ? {
          backgroundColor: colors.light.blue.secondary,
          borderColor: 'transparent',
          color: 'white',
        }
      : null
);

const setPriceAction = (e, price) => {
  switch (price) {
    case 'Send 50':
      sendAmount50();
      break;
    case 'Send 74':
      sendAmount75();
      break;
    case 'Send 100':
      sendAmount100();
      break;
    case 'Send 150':
      sendAmount150();
      break;
    case 'Send 200':
      sendAmount200();
      break;
    case 'Send Suggestion':
      sendSuggest();
      break;
    default:
      return;
  }
};

function OfferPriceBtnSet(props: any): any {
  const { prices, updateOfferPrice, currentAmount, isCounter, currLabel, currInitial, offer, customStyle = {} } = props;
  const send50Btn = useRef(null);
  const send75Btn = useRef(null);
  const send100Btn = useRef(null);
  const send150Btn = useRef(null);
  const send200Btn = useRef(null);
  const sendSuggestionBtn = useRef(null);

  useOnClickTriggerTracking('Send 50', send50Btn, setPriceAction);
  useOnClickTriggerTracking('Send 74', send75Btn, setPriceAction);
  useOnClickTriggerTracking('Send 100', send100Btn, setPriceAction);
  useOnClickTriggerTracking('Send 150', send150Btn, setPriceAction);
  useOnClickTriggerTracking('Send 200', send200Btn, setPriceAction);
  useOnClickTriggerTracking('Send Suggestion', sendSuggestionBtn, setPriceAction);

  const offerBtn = {
    50: send50Btn,
    75: send75Btn,
    100: send100Btn,
    150: send150Btn,
    200: send200Btn,
    '???': sendSuggestionBtn,
  };

  const Amounts = prices.map(number => {
    if (offer && offer.suggest && number === '???') {
      return null;
    }

    return (
      <OfferPriceBtn
        ref={offerBtn[number]}
        isActive={Number(currentAmount) === number || (number === '???' && currentAmount === '???')}
        key={number}
        onClick={() => updateOfferPrice(number.toString())}
        data-value={number}
      >
        {`${currInitial}${currLabel}${number}`}
      </OfferPriceBtn>
    );
  });

  if ((isCounter && offer && offer.suggest && offer.price_original) || !isCounter) {
    return <OfferPriceBtnWrapper style={customStyle}>{Amounts}</OfferPriceBtnWrapper>;
  } else {
    return null;
  }
}

export default React.memo(OfferPriceBtnSet);
